import { Routes } from "@angular/router";
import { SkjemarammeverkComponent } from "./pages/skjemarammeverk/skjemarammeverk.component";
import { VeiledningComponent } from "./pages/veiledning/veiledning.component";
import { BekreftelseComponent } from "./pages/bekreftelse/bekreftelse.component";

export const sikkerInnsendingRoutes: Routes = [
  {
    path: "proff/veiledning",
    component: VeiledningComponent,
    pathMatch: "full"
  },
  {
    path: "privat/veiledning",
    component: VeiledningComponent,
    pathMatch: "full"
  },
  {
    path: "proff/bekreftelse",
    component: BekreftelseComponent,
    pathMatch: "full"
  },
  {
    path: "privat/bekreftelse",
    component: BekreftelseComponent,
    pathMatch: "full"
  },
  {
    path: "privat",
    component: SkjemarammeverkComponent,
    pathMatch: "full",
  },
  {
    path: "proff",
    component: SkjemarammeverkComponent,
    pathMatch: "full",
  }
];
